module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1272.c744f4b0.png";